module.exports = __webpack_public_path__ + "img/off_llenadora.53b08676.png";